import { Services } from "appworks/services/services";
import { arrayEquals } from "appworks/utils/collection-utils";
import { ValueList } from "appworks/utils/value-list";
import { slotModel } from "slotworks/model/slot-model";
import { Autoplay } from "./autoplay";

export class XBetAutoplay extends Autoplay {
    public init(): void {
        super.init();

        slotModel.onUpdate.add(() => this.setDynamicLimits());
    }

    protected setDynamicLimits(): void {
        const { autoplay } = slotModel.read();

        const lossLimitChanged = this.updateValues(autoplay.lossLimit, this.getLossLimits());
        const singleWinChanged = this.updateValues(autoplay.singleWinLimit, this.getSingleWinExceeds());

        if (lossLimitChanged || singleWinChanged) {
            slotModel.write({ autoplay });
        }
    }

    protected updateValues(list: ValueList<number>, values: number[]): boolean {
        if (!arrayEquals(values, list.values)) {
            const index: number = list.values?.indexOf(list.currentValue) ?? undefined;
            list.values = values;
            list.currentValue = list.values[index];
            list.defaultValue = list.currentValue;
            return true;
        } else {
            return false;
        }
    }

    protected getLossLimits(): number[] {
        const bet: number = Services.bet.getTotalStake();
        const multipliers: number[] = [10, 25, 50, 75];
        const lossLimits: number[] = [];
        for (const multiplier of multipliers) {
            lossLimits.push(multiplier * bet);
        }
        lossLimits.push(Number.MAX_VALUE);
        return lossLimits;
    }

    protected getSingleWinExceeds(): number[] {
        const bet: number = Services.bet.getTotalStake();
        const multipliers: number[] = [10, 25, 50, 75, 100];
        const singleWinExeeds: number[] = [];
        for (const multiplier of multipliers) {
            singleWinExeeds.push(multiplier * bet);
        }
        return singleWinExeeds;
    }
}
